export default __webpack_public_path__ + "static/media/image1.a0163d87.png";